import type { Schedule } from "@medplum/fhirtypes";
import { SCHEDULE_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

/**
 * Hook that subscribes to Schedule resource changes via WebSocket
 * and updates the TanStack DB collection in real-time.
 *
 * Must be used inside FhirDataStoreProvider.
 */
export const useScheduleSubscription = createSubscriptionHook<Schedule>("Schedule", SCHEDULE_COLLECTION_NAME);
